// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"822":"bf451e84","3934":"6e512f3e","4686":"70586020","8437":"033c43bd"}[chunkId] + ".chunk.css";
};